import React from 'react';

import styled from 'styled-components';

import AICISummaryCard from 'components/AiCompetitiveIntelligence/AICISummaryCard';
import {
  CMI_DIGEST_WATCHLIST_TYPE,
  CmiDigestWatchlistOverview,
  CmiDigestWatchlistType,
} from 'types/cmiDigestWatchlist';
import { pluralizeWord } from 'utils/helpers/string';

const Container = styled.div`
  display: flex;
  gap: 20px;
`;

const Count = styled.span`
  font-size: 28px;
  line-height: 1;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const Unit = styled.span`
  font-size: 14px;
  font-family: var(--font-regular);
  color: var(--text-primary);
`;

const communityCount = (count: number) => (
  <>
    <Count>{count}</Count>
    <Unit>{pluralizeWord(count, 'community', 'communities')}</Unit>
  </>
);

type Props = {
  overview?: CmiDigestWatchlistOverview;
  typeFilter: CmiDigestWatchlistType;
  onTypeFilterChange: (type: CmiDigestWatchlistType) => void;
};

const QuickFilterCards = ({ overview, typeFilter, onTypeFilterChange }: Props) => {
  const toggle = (value: CmiDigestWatchlistType) =>
    onTypeFilterChange(typeFilter === value ? CMI_DIGEST_WATCHLIST_TYPE.ANY : value);

  return (
    <Container>
      <AICISummaryCard
        title="Needs Attention"
        iconClassName="gold"
        iconImageSrc="/icons/notifications.svg"
        subtitle={communityCount(overview?.needs_attention_count ?? 0)}
        selected={typeFilter === CMI_DIGEST_WATCHLIST_TYPE.NEEDS_ATTENTION}
        onClick={() => toggle(CMI_DIGEST_WATCHLIST_TYPE.NEEDS_ATTENTION)}
      />
      <AICISummaryCard
        title="Other"
        iconClassName="blue"
        iconImageSrc="/icons/format-list-bulleted.svg"
        subtitle={communityCount(overview?.other_count ?? 0)}
        selected={typeFilter === CMI_DIGEST_WATCHLIST_TYPE.OTHER}
        onClick={() => toggle(CMI_DIGEST_WATCHLIST_TYPE.OTHER)}
      />
      <AICISummaryCard
        title="With New Competitor Incentives"
        iconClassName="mint"
        iconImageSrc="/icons/local-offer.svg"
        subtitle={communityCount(overview?.incentives_communities_count ?? 0)}
        selected={typeFilter === CMI_DIGEST_WATCHLIST_TYPE.INCENTIVES}
        onClick={() => toggle(CMI_DIGEST_WATCHLIST_TYPE.INCENTIVES)}
      />
      <AICISummaryCard
        title="With New Reviews"
        iconClassName="pink"
        iconImageSrc="/icons/review.svg"
        subtitle={communityCount(overview?.reviews_communities_count ?? 0)}
        selected={typeFilter === CMI_DIGEST_WATCHLIST_TYPE.REVIEWS}
        onClick={() => toggle(CMI_DIGEST_WATCHLIST_TYPE.REVIEWS)}
      />
    </Container>
  );
};

export default QuickFilterCards;
